/**
 * 判断是否是服务器环境
 * @returns
 */
export const isServer = (() => {
  // 判断是否在服务器环境
  const isNode = typeof process !== 'undefined' && process.versions?.node != null // 使用可选链简化 Node.js 环境判断
  const isDeno = typeof window !== 'undefined' && 'Deno' in window // 判断是否在 Deno 环境
  return isDeno || isNode || typeof window === 'undefined' // 合并判断
})()
